<div class="mat-bg-surface flex flex--column">
  <mat-toolbar>
    <h1>Invoicing</h1>
    <span class="spacer"></span>
    <button
      mat-mini-fab
      matTooltip="Reset cache and fetch latest data for all invoices"
      (click)="reload()"
      [disabled]="pending() || !StartDate() || !EndDate()"
      [class.rotating]="pending()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-toolbar>

  <div class="cell-actions">
    <mat-form-field>
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [min]="minDate" [max]="maxDate" [rangePicker]="picker">
        <input required matStartDate [(ngModel)]="StartDate" placeholder="Start date" />
        <input required matEndDate [(ngModel)]="EndDate" placeholder="End date" />
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <table mat-table [dataSource]="invoices()" [trackBy]="trackBy" multiTemplateDataRows>
    <ng-container matColumnDef="ClientCode">
      <th mat-header-cell *matHeaderCellDef>Client Code</th>
      <td mat-cell *matCellDef="let invoice">
        <a [routerLink]="['/app/client-accounts/view', invoice.ClientCode]">{{ invoice.ClientCode }}</a>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="ClientName">
      <th mat-header-cell *matHeaderCellDef>Client Name</th>
      <td mat-cell *matCellDef="let invoice">{{ invoice.ClientName }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="AgreementNumber">
      <th mat-header-cell *matHeaderCellDef>Agreement #</th>
      <td mat-cell *matCellDef="let invoice">
        <a [routerLink]="['/app/agreements/view', invoice.AgreementNumber]">{{ invoice.AgreementNumber }}</a>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="Service">
      <th mat-header-cell *matHeaderCellDef>Service</th>
      <td mat-cell *matCellDef="let invoice">
        <a [routerLink]="['/app/agreements/view', invoice.AgreementNumber]">{{ invoice.Title }}</a>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="BillingCycle">
      <th mat-header-cell *matHeaderCellDef>Cycle</th>
      <td mat-cell *matCellDef="let invoice">{{ invoice.BillingCycle }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="Expiry">
      <th mat-header-cell *matHeaderCellDef>Expected</th>
      <td mat-cell *matCellDef="let invoice">
        <span [class.mat-text-error]="invoice._invoiceIn! < 0">
          {{ invoice.NextInvoiceDate | date: 'dd/MM/y' }}
          @if (invoice._invoiceIn! < 0) {
            <strong> ({{ -invoice._invoiceIn! }} day{{ invoice._invoiceIn! > -2 ? '' : 's' }}) </strong>
          }
        </span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="Amount">
      <th mat-header-cell *matHeaderCellDef>Amount</th>
      <td mat-cell *matCellDef="let invoice" matTooltip="Single invoice: ${{ invoice._invoiceSingle | number }}">
        ${{ invoice._invoiceSum | number }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        To be invoiced total:
        <br />
        <strong> ${{ toBeInvoicedSum() | number: '.0-2' }} </strong>
        <br />
        Overdue invoices:
        <br />

        <strong [class]="{ 'mat-text-error': overdueInvoicesSum }">
          ${{ overdueInvoicesSum() | number: '.0-2' }}
        </strong>
      </td>
    </ng-container>

    <ng-container matColumnDef="composition">
      <td
        mat-cell
        *matCellDef="let invoice"
        [attr.colspan]="columnsToDisplay.length"
        class="mat-bg-primary-container mat-text-on-primary-container"
      >
        <div class="flex flex--column">
          @for (item of invoice['_composition']; track item) {
            <div class="flex flex--row justify-end">
              <span> {{ $index + 1 | ordinal }} invoice on {{ item | date: 'dd/MM/y' }}: </span>
              <span>${{ invoice['_invoiceSingle'] | number: '.0-2' }}</span>
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr
      mat-row
      *matRowDef="let invoice; columns: columnsToDisplay"
      (click)="expand(invoice.AgreementNumber)"
      style="cursor: pointer"
    ></tr>

    <tr mat-row *matRowDef="let invoice; columns: ['composition']" [hidden]="!expanded()[invoice.AgreementNumber]"></tr>
    <tr mat-footer-row *matFooterRowDef="columnsToDisplay"></tr>
  </table>
</div>
